import { useEffect, useState } from 'react'
import { type Locale } from 'invictus-sdk-typescript'

import { getTranslationMessages } from '@Utils/i18n'

type Messages = Record<string, string>

type AllMessagesState = {
  locale: string
  messages?: Messages
}

export const useAllMessages = (locale: Locale): AllMessagesState => {
  const [state, setState] = useState<AllMessagesState>({ locale })
  useEffect(() => {
    const getAllMessagesAsync = async () => {
      const messages = await getTranslationMessages(locale)
      setState({ locale, messages })
    }
    void getAllMessagesAsync()
  }, [locale])

  return state
}
